import React, { useEffect, useState } from 'react';
import {
	Accordion,
	AccordionBody,
	AccordionHeader,
	AccordionItem,
	Card,
	CardBody,
	CardTitle,
	Row,
	Col,
	CardHeader,
	NavItem,
	TabContent,
	TabPane,
	Table
} from 'reactstrap';
import CountryFlag from '../../common/countryFlag';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getLoadingBookingsLoading, setSelectedTaskSchedule } from 'store/actions';
import Spinners from 'components/Common/Spinner';
import classnames from 'classnames';
//i18n
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import getShippingLineLinkUrl from 'helpers/shipping_line_url';
import withRoleBasedAccess from 'components/Common/withRoleBasedAccess';
import allInternalTraxaaRolesData from 'constants/allRoles';
import { NavLink } from 'react-router-dom';
import BookingList from './TaskSchedules/BookingList';
import PendingAndOtherTask from './TaskSchedules/PendingAndOtherTask';
import countryFlag from '../../common/countryFlag';

const TaskSchedule = () => {
	//const [activeTab, setactiveTab] = useState(1);
	const [getLoadingActivityData, setLoadingActivityData] = useState([]);
	const [getLoadingBookingsCustomerType, setLoadingBookingsCustomerType] = useState('ALL');
	const [getSiActivityData, setSiActivityData] = useState([]);
	const [getVgmActivityData, setVgmActivityData] = useState([]);
	const [getOtherTasksActivityData, setOtherTasksActivityData] = useState([]);
	const [getPendingTasksActivityData, setPendingTasksActivityData] = useState([]);

	const [getDatesArray, setDatesArray] = useState([]);
	//const [selectedDatesArrayValue, setSelectedDatesArrayValue] = useState('');
	//const [selectedFullDate, setSelectedFullDate] = useState(moment());

	const DashboardProperties = createSelector(
		state => state.Dashboard,
		dashboard => ({
			isLoading: dashboard.getLoadingBookingsLoading,
			dataValue: dashboard.getLoadingBookingData,
			activeTab: dashboard.selectedTaskSchedule.activeTab,
			selectedDatesArrayValue: dashboard.selectedTaskSchedule.selectedDatesArrayValue,
			selectedFullDate: dashboard.selectedTaskSchedule.selectedFullDate
		})
	);

	const LayoutProperties = createSelector(
		state => state.Layout,
		layout => ({
			layoutType: layout.layoutModeType
		})
	);

	const { isLoading, dataValue, activeTab, selectedDatesArrayValue, selectedFullDate } =
		useSelector(DashboardProperties);

	const { layoutType } = useSelector(LayoutProperties);

	const pendingTasktoggle = id => {
		if (open === id) {
			pendingTasksetOpen();
		} else {
			pendingTasksetOpen(id);
		}
	};
	const [pendingTaskopen, pendingTasksetOpen] = useState('1');

	useEffect(() => {
		if (dataValue?.outputTasks && dataValue?.outputTasks?.loadingTasks) {
			setLoadingActivityData(dataValue?.outputTasks?.loadingTasks);
		}
		if (dataValue?.outputTasks && dataValue?.outputTasks?.siTasks) {
			setSiActivityData(dataValue?.outputTasks?.siTasks);
		}
		if (dataValue?.outputTasks && dataValue?.outputTasks?.vgmTasks) {
			setVgmActivityData(dataValue?.outputTasks?.vgmTasks);
		}
		if (dataValue?.outputTasks && dataValue?.outputTasks?.otherTasks) {
			setOtherTasksActivityData(dataValue?.outputTasks?.otherTasks);
		}
		if (dataValue?.outputTasks && dataValue?.outputTasks?.pendingTasks) {
			setPendingTasksActivityData(dataValue?.outputTasks?.pendingTasks);
		}
	}, [dataValue]);

	const dispatch = useDispatch();
	useEffect(() => {
		dispatch(getLoadingBookingsLoading(selectedFullDate));
	}, [dispatch]);

	useEffect(() => {
		getNextAndPreviosFourDates(selectedFullDate);
	}, []);

	const getNextAndPreviosFourDates = selectedDate => {
		var currentDate = selectedDate;
		var weekStart = currentDate.clone().startOf('isoWeek');
		var previousWeekStart = currentDate.clone().subtract(1, 'weeks').startOf('isoWeek');
		var nextWeekStart = currentDate.clone().add(1, 'weeks').startOf('isoWeek');
		var days = [];

		for (var i = -1; i <= 6; i++) {
			let dateNumber = moment(weekStart).add(i, 'days').format('Do');
			let monthName = moment(weekStart).add(i, 'days').format('MMM');
			let dayName = moment(weekStart).add(i, 'days').format('dd');
			let fulldate = moment(weekStart).add(i, 'days');

			days.push({
				dateNumber,
				monthName,
				dayName,
				fulldate,
				previousWeekStart,
				nextWeekStart,
				currentDate
			});
		}
		setDatesArray([...days]);
	};

	const reloadBookings = () => {
		dispatch(getLoadingBookingsLoading(selectedFullDate));
	};

	const setactiveTab = tab => {
		dispatch(
			setSelectedTaskSchedule({
				selectedDatesArrayValue: selectedDatesArrayValue,
				selectedFullDate: selectedFullDate,
				activeTab: tab
			})
		);
	};

	return (
		<React.Fragment>
			<Card>
				<CardHeader className={layoutType === 'light' ? 'bg-primary-subtle ' : 'bg-primary-subtle '}>
					<h5 className="text-primary">Tasks Schedule</h5>
				</CardHeader>

				<CardBody>
					<ul className="nav nav-stretch nav-pills nav-pills-custom nav-pills-active-custom d-flex justify-content-between mb-8 px-5">
						<li
							key={`date-first`}
							className="nav-item btn p-0 ms-0 align-self-center"
							onClick={() => {
								getNextAndPreviosFourDates(getDatesArray[0].previousWeekStart);
							}}
						>
							<i className={`font-size-18 bx bxs-left-arrow-circle`} />
						</li>
						{getDatesArray.map((datesData, index) => {
							return (
								<li
									key={`date-${index + 1}`}
									className="nav-item p-0 ms-0"
									onClick={() => {
										dispatch(getLoadingBookingsLoading(datesData.fulldate));
										//setSelectedFullDate(datesData.fulldate);
										dispatch(
											setSelectedTaskSchedule({
												selectedDatesArrayValue: moment(datesData.fulldate).format('Do'),
												activeTab: activeTab,
												selectedFullDate: datesData.fulldate
											})
										);
									}}
								>
									<span
										className={
											selectedDatesArrayValue == datesData.dateNumber
												? 'nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px active'
												: 'nav-link btn d-flex flex-column flex-center rounded-pill min-w-45px'
										}
									>
										<span className="font-size-11">{datesData.dayName}</span>
										<span className="font-size-11">{datesData.dateNumber}</span>
										<span className="font-size-11">{datesData.monthName}</span>
									</span>
								</li>
							);
						})}
						<li
							key={`date-last`}
							className="nav-item btn p-0 ms-0 align-self-center"
							onClick={() => {
								getNextAndPreviosFourDates(getDatesArray[0].nextWeekStart);
							}}
						>
							<i className={`font-size-18 bx bxs-right-arrow-circle`} />
						</li>
					</ul>
					<div className="p-3">
						{isLoading ? (
							<Row>
								<Col sm="12">
									<div className="pt-5 pb-5 text-center">
										<Spinners setLoading={() => {}} />
									</div>
								</Col>
							</Row>
						) : (
							<div>
								<div className="wizard clearfix mt-4">
									<div className="steps clearfix">
										<ul>
											<NavItem className={classnames({ current: activeTab === 1, 'font-size-12': true })}>
												<NavLink
													className={classnames({ current: activeTab === 1 })}
													onClick={() => {
														setactiveTab(1);
													}}
												>
													<span className="number">
														<i className="fas fa-truck"></i>
													</span>{' '}
													Loadings ({getLoadingActivityData.length})
												</NavLink>
											</NavItem>
											<NavItem className={classnames({ current: activeTab === 2, 'font-size-12': true })}>
												<NavLink
													className={classnames({ active: activeTab === 2 })}
													onClick={() => {
														setactiveTab(2);
													}}
												>
													<span className="number">
														<i className="fas fa-file"></i>
													</span>{' '}
													SI Files ({getSiActivityData.length})
												</NavLink>
											</NavItem>
											<NavItem className={classnames({ current: activeTab === 3, 'font-size-12': true })}>
												<NavLink
													className={classnames({ active: activeTab === 3 })}
													onClick={() => {
														setactiveTab(3);
													}}
												>
													<span className="number">
														<i className="fas fa-file"></i>
													</span>{' '}
													VGM Files ({getVgmActivityData.length})
												</NavLink>
											</NavItem>
										</ul>
									</div>

									<div className="content clearfix">
										<TabContent activeTab={activeTab} className="body">
											<TabPane tabId={1}>
												<Row>
													{(getLoadingActivityData || [])
														?.sort((a, b) => a?.taskIndex - b?.taskIndex)
														.filter(item =>
															getLoadingBookingsCustomerType === 'ALL'
																? true
																: getLoadingBookingsCustomerType === 'Other'
																? item?.bookingDetails?.bookingCustomer !== 'TBA'
																: item?.bookingDetails?.bookingCustomer === 'TBA'
														)
														.map((item, index) => (
															<BookingList
																key={index}
																index={index}
																item={item}
																reloadBookings={() => reloadBookings()}
															/>
														))}

													{(getLoadingActivityData || [])?.length === 0 && (
														<div className="text-center mt-5">No Bookings Found</div>
													)}
												</Row>
											</TabPane>
											<TabPane tabId={2}>
												<Row>
													{(getSiActivityData || [])
														?.sort((a, b) => a?.taskIndex - b?.taskIndex)
														.filter(item =>
															getLoadingBookingsCustomerType === 'ALL'
																? true
																: getLoadingBookingsCustomerType === 'Other'
																? item?.bookingDetails?.bookingCustomer !== 'TBA'
																: item?.bookingDetails?.bookingCustomer === 'TBA'
														)
														.map((item, index) => (
															<BookingList
																key={index}
																index={index}
																item={item}
																reloadBookings={() => reloadBookings()}
															/>
														))}

													{(getSiActivityData || [])?.length === 0 && (
														<div className="text-center mt-5">No Bookings Found</div>
													)}
												</Row>
											</TabPane>
											<TabPane tabId={3}>
												<Row>
													{(getVgmActivityData || [])
														?.sort((a, b) => a?.taskIndex - b?.taskIndex)
														.filter(item =>
															getLoadingBookingsCustomerType === 'ALL'
																? true
																: getLoadingBookingsCustomerType === 'Other'
																? item?.bookingDetails?.bookingCustomer !== 'TBA'
																: item?.bookingDetails?.bookingCustomer === 'TBA'
														)
														.map((item, index) => (
															<BookingList
																key={index}
																index={index}
																item={item}
																reloadBookings={() => reloadBookings()}
															/>
														))}

													{(getVgmActivityData || [])?.length === 0 && (
														<div className="text-center mt-5">No Bookings Found</div>
													)}
												</Row>
											</TabPane>
											<TabPane tabId={4}>
												{getOtherTasksActivityData.length > 0 ? (
													<Row>
														<Col xl="12">
															{(getOtherTasksActivityData || [])
																?.sort(
																	(a, b) => moment(a?.bookingEtd || '').unix() - moment(b?.bookingEtd || '').unix()
																)
																.filter(item =>
																	getLoadingBookingsCustomerType === 'ALL'
																		? true
																		: getLoadingBookingsCustomerType === 'Other'
																		? item?.bookingDetails?.bookingCustomer !== 'TBA'
																		: item?.bookingDetails?.bookingCustomer === 'TBA'
																)
																.map((item, index) => (
																	<PendingAndOtherTask
																		key={index}
																		index={index}
																		item={item}
																		pendingTasktoggle={id => pendingTasktoggle(id)}
																		pendingTaskopen={pendingTaskopen}
																	/>
																))}
														</Col>
													</Row>
												) : (
													<div className="text-center mt-5">No Bookings Found</div>
												)}
											</TabPane>
											<TabPane tabId={5}>
												<Row>
													<Col xl="12">
														{(getPendingTasksActivityData || [])
															?.sort((a, b) => moment(a?.bookingEtd || '').unix() - moment(b?.bookingEtd || '').unix())
															.filter(item =>
																getLoadingBookingsCustomerType === 'ALL'
																	? true
																	: getLoadingBookingsCustomerType === 'Other'
																	? item?.bookingDetails?.bookingCustomer !== 'TBA'
																	: item?.bookingDetails?.bookingCustomer === 'TBA'
															)
															.map((item, index) => (
																<PendingAndOtherTask
																	key={index}
																	index={index}
																	item={item}
																	pendingTasktoggle={id => pendingTasktoggle(id)}
																	pendingTaskopen={pendingTaskopen}
																/>
															))}
													</Col>
												</Row>
											</TabPane>
										</TabContent>
									</div>
								</div>
								{/* <div className="text-center mt-5">
                <Link to="#" className="btn btn-primary waves-effect waves-light btn-sm">
                  View More <i className="mdi mdi-arrow-right ms-1" />
                </Link>
              </div> */}
							</div>
						)}
					</div>
				</CardBody>
			</Card>
		</React.Fragment>
	);
};
export default withRoleBasedAccess(TaskSchedule, [...allInternalTraxaaRolesData]);
